import React from 'react';
import { useWebsiteLayoutContext } from '../../../../context/WebsiteLayoutContext';
import ButtonGroup, { ButtonGroupOption } from '../../../ButtonGroup/ButtonGroup';
import ThemeFieldWrapper from '../ThemeFieldWrapper/ThemeFieldWrapper';

const ThemeLayoutSelector = () => {
  const { layout, setPreviewLayout } = useWebsiteLayoutContext();

  const layoutOptions: ButtonGroupOption[] = [
    { label: 'Multi-page', value: 'multi-page' },
    { label: 'Single page', value: 'single-page' },
  ];

  const onLayoutChange = (layout: string) => {
    setPreviewLayout(layout);
  };

  const getLayoutLabel = (layout: string) => {
    return layoutOptions.find(option => option.value === layout)?.label || '';
  };

  return (
    <ThemeFieldWrapper fieldLabel="Layout" fieldValue={getLayoutLabel(layout)}>
      <ButtonGroup options={layoutOptions} selectedOption={layout} onClick={onLayoutChange} />
    </ThemeFieldWrapper>
  );
};

export default ThemeLayoutSelector;
